/* Focus na openen van de cart en het mobiele menu.

   theme.js zet bij het openen van de cart drawer en het mobiele menu de focus
   op het eerste bedieningselement (het kruisje, het logo) en bij een submenu
   op de terugknop. Voor toetsenbordgebruikers is dat goed: zij zien een
   focusring en weten waar ze zijn. Na een tik of klik tekende dezelfde
   programmatische focus soms (vooral in Safari) een vierkante ring om dat
   element, terwijl er niets met het toetsenbord gebeurd was.

   Dit script onthoudt hoe er het laatst bediend is. Was dat met een
   aanwijzer (muis, vinger, pen), dan verhuist het na het openen de focus naar
   het paneel zelf. Dat paneel heeft tabindex="-1" en outline: none in
   theme.css, dus er verschijnt geen ring, en de focus blijft wel binnen de
   dialoog: de eerstvolgende Tab landt gewoon op het eerste element. Met het
   toetsenbord verandert er niets.

   Het staat als los bestand naast theme.js en laadt direct daarna (beide
   defer, dus in volgorde). Het leest alleen de classes die theme.js al zet
   (`is-open`, `is-sub-open`) en raakt de logica daar niet aan. */

(function () {
  'use strict';

  var keyboard = false;
  document.addEventListener('keydown', function () { keyboard = true; }, true);
  document.addEventListener('pointerdown', function () { keyboard = false; }, true);

  function watch(dialog, panel) {
    if (!dialog || !panel) return;
    new MutationObserver(function () {
      if (keyboard) return;
      var open = dialog.classList.contains('is-open');
      var active = document.activeElement;
      if (!open || !active || active === panel || !dialog.contains(active)) return;
      try {
        panel.focus({ preventScroll: true });
      } catch (error) {
        panel.focus();
      }
      /* Zelfde reden als in theme.js: .cart-drawer is een scrollcontainer
         en een focus kan hem een stukje opzij schuiven. */
      dialog.scrollLeft = 0;
    }).observe(dialog, { attributes: true, attributeFilter: ['class'] });
  }

  var cart = document.getElementById('CartDrawer');
  watch(cart, cart && cart.querySelector('[data-cart-drawer-panel]'));

  var nav = document.querySelector('.mobile-nav--js');
  watch(nav, nav);
})();
